// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

(function($) {
  'use strict';

  var responsiveness = {

    init: function() {

      $('body').addClass('responsiveness');

      var $btn_search = $('<a/>')
        .addClass('small-nav__search small-nav__item')
        .html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32"><path d="M28.072 24.749l-6.046-6.046c0.912-1.499 1.437-3.256 1.437-5.139 0-5.466-4.738-10.203-10.205-10.203-5.466-0-9.898 4.432-9.898 9.898 0 5.467 4.736 10.205 10.203 10.205 1.818 0 3.52-0.493 4.984-1.349l6.078 6.080c0.597 0.595 1.56 0.595 2.154 0l1.509-1.507c0.594-0.595 0.378-1.344-0.216-1.938zM6.406 13.258c0-3.784 3.067-6.853 6.851-6.853 3.786 0 7.158 3.373 7.158 7.158s-3.067 6.853-6.853 6.853-7.157-3.373-7.157-7.158z"/></svg>')
        .attr({
          'title': 'Open search',
          'href': '#',
          'tabindex': 1
        })
        .on('click', function(event){
          event.preventDefault();
          if ($('html').hasClass('js-search_open')) {
            closeSearch();
          } else {
            openSearch();
          }
        });
      var $btn_hamburger = $('<a/>')
        .addClass('small-nav__menu small-nav__item')
        .html('<svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.247 8.996C6.12 8.84 6 8.673 5.89 8.5c-.494-.08-.874-.617-.874-1.266 0-.213.04-.413.113-.59C5.044 6.25 5 5.84 5 5.417 5 2.425 7.24 0 10 0s5 2.425 5 5.417c0 .388-.038.766-.11 1.13.1.2.158.435.158.687 0 .634-.363 1.16-.84 1.26-.185.43-.76 1.633-1.708 2.528V20H8.333v-8.484c-1.017-.675-1.717-1.804-2.086-2.52zM0 16.666V20h8.333v-8.333C6.13 14.287.357 14.21 0 16.665zm20.833 0V20H12.5v-8.333c2.205 2.62 7.976 2.543 8.333 4.998z" fill="#444" fill-rule="evenodd"></path></svg>')
        .attr({
          'title': 'Open menu',
          'href': '#',
          'tabindex': 1
        })
        .on('click', function(event){
          event.preventDefault();
          if ($('html').hasClass('js-nav_open')) {
            closeMenu();
          } else {
            openMenu();
          }
        });
      var $small_nav = $('<nav/>').addClass('small-nav').append($btn_search).append($btn_hamburger);
      $('.cw-header').prepend($small_nav);
      if ($(window).width() < 747) {
        $('.cw-header__nav__item.cw-header__nav__item--help').before($('.cw-header__nav__item.cw-header__nav__item--user'));
      }

      // open & close sidebar
      var $content = $('body');
      $('.cw-header').find('.cw-header__nav, .cw-searchbox, .cw-header__sell, .small-nav')
        .on('mousedown.responsiveness touchstart.responsiveness', function(evt){
          evt.stopPropagation();
        });

      var openMenu = function() {
        $('html').addClass('js-nav_open');
        $content
          .on('mousedown.closeMenu touchstart.closeMenu', function(evt){
            if ($(evt.target).closest('.mfp-wrap').length < 1) {
              evt.stopPropagation();
              evt.preventDefault();
              closeMenu();
            }
          });
        // AB conversion for opening mobile navigation
        if (typeof(AB) != 'undefined' && AB.conversion) {
          AB.conversion('open_mobile_navigation');
        }
      };

      var closeMenu = function() {
        $('html').removeClass('js-nav_open');
        $('#cw-searchbox').find('input').blur();
        $content.off('mousedown.closeMenu').off('touchstart.closeMenu');
      };

      var openSearch = function() {
        $('html').addClass('js-search_open');
        $('.cw_dropmenu').removeClass('open');
        $content
          .on('mousedown.closeSearch touchstart.closeSearch', function(evt){
            evt.stopPropagation();
            evt.preventDefault();
            closeSearch();
          });
        $('#cw-searchbox').find('input').trigger('focus');
      };

      var closeSearch = function() {
        $('html').removeClass('js-search_open');
        $('#cw-searchbox').find('input').blur();
        $content.off('mousedown.closeSearch').off('touchstart.closeSearch');
      };
    }
  };

  $(document).ready(function() {
    responsiveness.init();
  });

})(jQuery);
